import moment from 'moment';
import { ProfileLogo } from '../../ambient_solo/components/baseComponents';
import { Tooltip } from 'antd';
import { CalendarMobileIcon, StethMobileIcon } from '../../../icons';
import { NavLink } from 'react-router-dom';
import AppointmentActionMenu from './AppointmentsMenu';

const nonVCAIntakeStatus = 'Aura encounter';
export const columns = (
  filteredData,
  onCellClick,
  practitionersAndPatients,
  currentPractitioner,
  hasVCAProcessedWorkflowAccess,
  setDeleteText,
  setIsDeleteOpen,
  setQRCodeURL,
  setIsQRCodeOpen,
  setEditAppointmentOpen,
  setIsnotificationHistoryOpen,
  setShowConvertAppointmentToAuraModal,
  setSelectedAppointmentForAuraEncounter,
  setFilteredData,
  setData,
  setStoreRecord
) =>
  [
    {
      title: <span className="font-[700]"></span>,
      dataIndex: 'practitioner_Name',
      key: 'practitioner_Name',
      // sorter: doctor_nameSorter,
      onCell: onCellClick,
      width: '22%',
      render: (text, record) => {
        const { date, time } = record?.appointmentDateTime || {};

        // status
        let statusResponseText = 'Not Started';
        let statusResponseColor = 'new-response';
        if (
          record?.intakeStatus === 'Completed' &&
          (!hasVCAProcessedWorkflowAccess || !record?.isProcessed)
        ) {
          statusResponseText = (
            <div className="icon">
              Completed
              <NavLink to={`/schedule/${record?.appt_uuid}`}></NavLink>
            </div>
          );
          statusResponseColor = 'completed-response';
        } else if (
          (record?.intakeStatus === 'Completed' ||
            record?.intakeStatus === 'InProgress') &&
          hasVCAProcessedWorkflowAccess &&
          record?.isProcessed
        ) {
          statusResponseText = (
            <div className="icon">
              Processed
              <NavLink to={`/schedule/${record?.appt_uuid}`}></NavLink>
            </div>
          );
          statusResponseColor = 'processed-response';
        } else if (record?.intakeStatus === 'Unavailable') {
          statusResponseText = nonVCAIntakeStatus;
          statusResponseColor = 'unavailable-response';
        } else if (record?.intakeStatus === 'InProgress') {
          statusResponseText = <div className="icon">In Progress</div>;
          statusResponseColor = 'inprogress-response';
        } else if (
          record?.intakeStatus === 'partial_completed' &&
          (!hasVCAProcessedWorkflowAccess || !record?.isProcessed)
        ) {
          statusResponseText = 'Partial Summary';
          statusResponseColor = 'partial-response';
        } else if (
          record?.intakeStatus === 'partial_completed' &&
          hasVCAProcessedWorkflowAccess &&
          record?.isProcessed
        ) {
          statusResponseText = (
            <div className="icon">
              Processed
              <NavLink to={`/schedule/${record?.appt_uuid}`}></NavLink>
            </div>
          );
          statusResponseColor = 'processed-response';
        } else if (
          record?.intakeStatus === 'New' &&
          record?.notification_status?.email?.patient_intake_reminder?.event ===
            'clicked'
        ) {
          statusResponseText = 'Not Started';
          statusResponseColor = 'new-response';
        } else if (
          record?.intakeStatus === 'New' &&
          record?.notification_status?.email?.patient_intake_reminder?.event ===
            'opened'
        ) {
          statusResponseText = 'Not Started';
          statusResponseColor = 'new-response';
        } else if (
          (record?.intakeStatus === 'New' &&
            record?.notification_status?.email?.patient_intake_reminder
              ?.event === 'delivered') ||
          record?.notification_status?.sms?.patient_intake_reminder?.event ===
            'delivered'
        ) {
          statusResponseText = 'Not Started';
          statusResponseColor = 'new-response';
        } else if (
          (record?.intakeStatus === 'New' &&
            record?.notification_status?.email?.patient_intake_reminder
              ?.event === 'failed') ||
          record?.notification_status?.email?.patient_intake_reminder?.event ===
            'bounced' ||
          record?.notification_status?.sms?.patient_intake_reminder?.event ===
            'exception'
        ) {
          statusResponseText = 'Not Started';
          statusResponseColor = 'new-response';
        } else if (record?.intakeStatus === 'Summary InProgress') {
          statusResponseText = 'Summarizing';
          statusResponseColor = 'summary-inprogress-response';
        }
        const localDateString = moment
          .utc(record?.appointmentDateTime?.date, 'MMM Do, YYYY hh:mm A')
          .format('MMM Do, YYYY');
        const localTimeString = moment.utc(time, 'hh:mm A').format('h:mm A');

        return (
          <>
            <div className="flex w-full items-center">
              <div className="flex items-center ">
                <ProfileLogo
                  name={`${record.practitioner_firstName} ${record.practitioner_lastName}`}
                  className={'profile-popover-logo mr-2 sm:mr-2 lg:mr-3 '}
                />
                <div>
                  <div className="flex-grow">
                    {/* Patient Name and DOB  */}
                    <div>
                      <div className="icon">
                        <div
                          className="name"
                          style={{ fontSize: '14px', fontWeight: '500' }}
                        >
                          {record?.patient_Name}
                        </div>
                      </div>
                      <div className="dob">DOB : {record?.dateofBirth}</div>
                    </div>
                    {/* Condition */}
                    <div>
                      <div>{record?.condition_name}</div>
                    </div>
                    {/* status */}
                    <div className="notification-icons">
                      <span className={statusResponseColor}>
                        {statusResponseText}
                      </span>
                      {/* <span>{additionalIcon}</span> */}
                    </div>

                    {/* practitioner Name */}
                    <div className="dob flex">
                      <span>
                        <StethMobileIcon />
                      </span>
                      <span className="ml-1">{record.practitioner_Name}</span>
                    </div>

                    {/* Appointment Date and time  */}
                    <div>
                      {record.isExpired ? (
                        <Tooltip title="Appointment is expired" placement="top">
                          <div className="flex">
                            <span className="">
                              <CalendarMobileIcon />
                            </span>
                            {currentPractitioner?.org_settings
                              ?.show_appointment_time ? (
                              <span className="dob ml-1 expired-appointment-color">
                                {localDateString}
                                <span
                                  className="ml-1 expired-appointment-color"
                                  style={{
                                    fontSize: '13px',
                                  }}
                                >
                                  {localTimeString}
                                </span>
                              </span>
                            ) : (
                              <span className="dob ml-1 expired-appointment-color">
                                {moment(date, 'MMM Do, YYYY hh:mm A').format(
                                  'MMM Do, YYYY'
                                )}
                              </span>
                            )}
                          </div>
                        </Tooltip>
                      ) : (
                        <div>
                          <div className="flex">
                            <span className="">
                              <CalendarMobileIcon />
                            </span>
                            {currentPractitioner?.org_settings
                              ?.show_appointment_time ? (
                              <span className="dob ml-1">
                                {localDateString}
                                <span
                                  className="ml-1"
                                  style={{
                                    fontSize: '13px',
                                    color: '#777777',
                                  }}
                                >
                                  {localTimeString}
                                </span>
                              </span>
                            ) : (
                              <span className="dob ml-1">
                                {moment(date, 'MMM Do, YYYY hh:mm A').format(
                                  'MMM Do, YYYY'
                                )}
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: ' ',
      key: 'actions',
      dataIndex: 'actions',
      width: '1%',

      render: (text, record) => {
        return (
          <AppointmentActionMenu
            record={record}
            setDeleteText={setDeleteText}
            setIsDeleteOpen={setIsDeleteOpen}
            setQRCodeURL={setQRCodeURL}
            setIsQRCodeOpen={setIsQRCodeOpen}
            setEditAppointmentOpen={setEditAppointmentOpen}
            setStoreRecord={setStoreRecord}
            setIsnotificationHistoryOpen={setIsnotificationHistoryOpen}
            setShowConvertAppointmentToAuraModal={
              setShowConvertAppointmentToAuraModal
            }
            setSelectedAppointmentForAuraEncounter={
              setSelectedAppointmentForAuraEncounter
            }
            setFilteredData={setFilteredData}
            setData={setData}
          />
        );
      },
    },
  ].filter(Boolean);
